import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData() {
  // Chỉ lấy các nhân viên ĐANG có bản ghi tạm giữ CCMG (BrokerDebtCertificate),
  // thay vì toàn bộ nhân viên (/employee/list-all). Trước đây dropdown liệt kê mọi
  // nhân viên nên khi chọn 1 người KHÔNG có bản ghi tạm giữ thì bảng trống —
  // nhìn như "chọn không ra". Giới hạn về đúng danh sách NV có bản ghi để chọn là ra.
  const res = await clientAPI(
    "get",
    `/brokerDebtCertificate?limit=100000&page=1`
  );
  const items = res?.items || [];

  const pickEmployee = (item) => item?.employee || item?.employeeObject || {};
  const pickId = (item) =>
    String(item?.employeeId ?? pickEmployee(item)?._id ?? "");

  return {
    // Index id -> fullName
    employee: items.reduce((acc, item) => {
      const id = pickId(item);
      if (id) acc[id] = pickEmployee(item)?.fullName ?? "";
      return acc;
    }, {}),
    employeeSearch: items
      .map((item) => {
        const emp = pickEmployee(item);
        return {
          key: pickId(item),
          value: emp?.fullName ?? "",
          code: emp?.code ?? "",
          phone: emp?.phone ?? "",
          identificationNumber: emp?.identificationNumber ?? "",
        };
      })
      .filter((x) => x.key),
  };
}

export function useCategories(shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categoriesBrokerDebtCertificate"],
    queryFn: () => fetchConstantData(),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
